module.exports = __webpack_public_path__ + "media/images/aloe/logo/nephos-red-6694d9bf5cdac4f7f834d20bd991846b.svg";